import Error from "./layouts/Error";
import SectionLoading from "@components/SectionLoading";
import { Status } from "@models/common";
import { twMerge } from "tailwind-merge";

interface SectionProps {
  className?: string;
  status: Status;
  children?: React.ReactNode;
  error: any;
  reload?: Function;
  bgImg?: string;
  loadingText?: string;
}

export const Section = ({ className, children, status, error, reload, bgImg, loadingText }: SectionProps) => {
  return (
    <div className={twMerge("flex flex-col justify-center flex-1", className)}>
      {status === "loading" && <SectionLoading bgImg={bgImg} loadingText={loadingText}></SectionLoading>}
      {status === "failed" && <Error {...error} reload={reload}></Error>}
      {status === "succeeded" && children}
    </div>
  );
};
